<template>
  <div class="popup small">
    <h4 class="popup__title middle">API ключ</h4>

    <span v-if="apiKey" class="popup__subtitle api-key-text">{{ apiKey }}</span>

    <div class="actions">
      <button v-if="apiKey" class="button btn-primary" @click="copyKey()">Скопировать</button>
      <button class="button btn-primary" @click="closePopup()">Закрыть</button>
    </div>
  </div>
</template>

<script>
import { popups } from '@/mixins/popups'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'apiKeyPopup',
  mixins: [popups],
  computed: {
    ...mapState({
      apiKey: (state) => state.popups.apiKey,
    }),
  },
  methods: {
    ...mapMutations({
      setShowApiKeyPopup: 'SHOW_API_KEY_POPUP',
      setApiKey: 'SET_API_KEY',
    }),
    async copyKey() {
      if (!this.apiKey) {
        return
      }
      try {
        await navigator.clipboard.writeText(this.apiKey)
      } catch (e) {
        this.$store.dispatch('showError', { errorMessage: 'Не удалось скопировать ключ' })
      }
    },
    closePopup() {
      this.setShowApiKeyPopup(false)
      this.setApiKey(null)
      this.toggleOverlay(false)
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.api-key-text {
  word-break: break-all;
  max-height: 70vh;
  overflow-y: auto;
}
</style>
